import { render, staticRenderFns } from "./RegionTeamMemberCounter.vue?vue&type=template&id=5c627c58&scoped=true"
import script from "./RegionTeamMemberCounter.vue?vue&type=script&lang=js"
export * from "./RegionTeamMemberCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c627c58",
  null
  
)

export default component.exports